<template>
  <card type="plain">
    <p-progress
      v-if="downloadProgress"
      :value="downloadProgress"
      type="success"
      style="
        bottom: 200px;
        left: 0%;
        /* width: 70%; */
        position: absolute;
        z-index: 9000;
        margin-top: 100px;
        /* border: 3px solid #73ad21; */
      "
      class="fixed-bottom mx-auto w-50"
    ></p-progress>
    <h4 slot="header" class="card-title">Descarga de reportes</h4>
    <collapse :multiple-active="false">
      <collapse-item name="1">
        <template slot="title"
          ><span class="lead">Socios & Membresias</span></template
        >
        <div class="container d-flex flex-wrap">
          <el-tooltip :open-delay="200" placement="top">
            <template #content>
              Prodras revisar la basde de datos pero<br />
              el resumen aun no se encuentra disponible.
            </template>
            <div class="col col-md-4 p-4">
              <div class="card col-10">
                <p class="card-header lead">Registro Personas</p>
                <p class="card-body">
                  Registro completo de las personas registradas en el GYM y sus
                  membresias activas
                </p>
                <button
                  class="btn-info btn"
                  @click="
                    renderCustomersReportXLSX(
                      'ListaPersonas_SinUpdateAutomatico'
                    )
                  "
                >
                  descargar
                </button>
                <!-- renderCustomersReportXLSX('ExportClientes_BaseSocios') -->
              </div>
            </div>
          </el-tooltip>
          <div class="col col-md-4 p-4">
            <div class="card col-10">
              <p class="card-header lead">Registro Accesos</p>
              <p class="card-body">
                Informe dinámico que detalla los accesos en una sucursal
                específica o en general, permitiendo además la posibilidad de
                filtrar por rango de fechas.
              </p>
              <button
                class="btn-info btn"
                :disabled="true"
                @click="renderAccessReportXLSX('RegistrosDeAcceso_PorHora')"
              >
                descargar
              </button>
            </div>
          </div>
          <!-- <div class="col col-md-4 p-4">
            <div class="card col-10">
              <p class="card-header lead">Registro Personas</p>
              <p class="card-body">
                Reporte completo de las personas registradas por el GYM y sus
                membresias activas
              </p>
              <button class="btn-info btn">descargar</button>
            </div>
          </div> -->
        </div>
      </collapse-item>
      <collapse-item name="2">
        <template slot="title"><span class="lead">Ventas</span></template>
        <div class="container d-flex flex-wrap">
          <div class="col col-md-4 p-4">
            <div class="card col-10">
              <p class="card-header lead">Master de Ventas</p>
              <p class="card-body">
                Este informe presenta un resumen de todas las ventas realizadas
                durante el período exportado. No incluye detalles específicos de
                los productos o servicios vendidos, siendo útil para la creación
                de tablas dinámicas
              </p>
              <button
                class="btn-info btn"
                :disabled="true"
                @click="renderCustomersReportXLSX('ListaPersonas')"
              >
                descargar
              </button>
            </div>
          </div>
        </div>
      </collapse-item>
      <collapse-item name="3">
        <template slot="title"><span class="lead">Inventarios</span></template>
        <div class="container d-flex flex-wrap">
          <div class="col col-md-4 p-4">
            <div class="card col-10">
              <p class="card-header lead">Registro Inventario</p>
              <p class="card-body">
                Exporta un listado que refleja el estado actual del inventario,
                ya sea de una sucursal específica o del total de sucursales
              </p>

              <button :disabled="true" class="btn-info btn">descargar</button>
            </div>
          </div>
        </div>
      </collapse-item>
      <collapse-item name="4">
        <template slot="title"><span class="lead">Pagos</span></template>
        <div>
          <div class="col col-md-4 p-4">
            <div class="card col-10">
              <p class="card-header lead"></p>
              <p class="card-body"></p>

              <button :disabled="true" class="btn-info btn">descargar</button>
            </div>
          </div>
        </div>
      </collapse-item>
    </collapse>
  </card>
</template>

<script>
import {
  Collapse,
  CollapseItem,
  Tabs,
  TabPane,
  Card,
} from "src/components/UIComponents";
import PProgress from "src/components/UIComponents/Progress.vue";
import { DatePicker, TimeSelect, Button, Tooltip } from "element-ui";

import XLSXpopulate from "xlsx-populate";
import { DateEnv } from "@fullcalendar/core";
import ExcelJS from "exceljs";

export default {
  components: {
    TabPane,
    Tabs,
    CollapseItem,
    Collapse,
    Card,
    PProgress,
    [DatePicker.name]: DatePicker,
    [Button.name]: Button,
    [Tooltip.name]: Tooltip,
  },
  watch: {
    // dateStart: function (newValue) {
    //   console.log("cambio");
    //   console.log(newValue);
    // },
  },
  data() {
    return {
      dateStart: null,
      dateEnd: null,
      customersReportTotal: 0,
      customersReportCurrent: 0,
    };
  },
  computed: {
    downloadProgress() {
      return (this.customersReportCurrent / this.customersReportTotal) * 100;
    },
  },
  methods: {
    async fetchCustomersCount() {
      await this.$MasterControlAPP
        .post(
          "",
          {
            Parameters: {},
          },
          {
            headers: {
              "Content-Type": "application/json",
              token: sessionStorage.getItem("jCxbraoQeD"),
              operation: "/v1/count/customers",
              // operation: JSON.parse(sessionStorage.getItem("wxZlBbdD4q")).MembershipsStatistics,
            },
          }
        )
        .then((response) => {
          // console.log(response.data.result);
          this.customersReportTotal = response.data.result;

          return response.data.result;
        })
        .catch((ex) => {
          console.error(ex);
        });
    },
    cleanString(input) {
      const pattern = /[^a-zA-Z0-9áéíóúÁÉÍÓÚñÑ.,\s-]/g;
      return input.replace(pattern, "").trim(); // Elimina caracteres que no cumplen con el patrón
    },
    cleanNum(input) {
      const pattern = /[^0-9]/g;
      return input.replace(pattern, "").trim();
    },
    cleanEmail(input) {
      const pattern = /[^a-zA-Z0-9.@\-_]+/g;
      return input.replace(pattern, "").trim();
    },
    async fetchTemplate(templateName) {
      const template = templateName;
      try {
        const response = await this.$XLSXTemplateDownload.post(
          "",
          {
            template: template,
          },
          {
            headers: {
              "Content-Type": "application/json",
              token: sessionStorage.getItem("jCxbraoQeD"),
            },
            responseType: "arraybuffer",
          }
        );
        // console.log("fetchTemplate");
        // console.log(response);
        // const workbook = await XLSXpopulate.fromDataAsync(response.data)
        // console.log(workbook);
        return response.data;
      } catch (error) {
        console.error("Error al cargar el archivo xlsx:", error);
        throw error;
      }
    },
    async renderCustomersReportXLSX(templateName) {
      this.$swal.fire({
        title: "Creando plantilla...",
        text: "Por favor espera",
        timerProgressBar: true,
        allowOutsideClick: false,
        didOpen: () => {
          this.$swal.showLoading();
        },
      });
      let data;
      // const filePath = "./assets/templates/ListaPersonas.xlsx";

      try {
        // const wsTemplate =
        //   customersReportWB.Sheets[customersReportWB.SheetNames["DATOS"]];
        const template = await this.fetchTemplate(templateName);
        data = await this.createXLSXCustomerReportData();

        if (data.length > 0) {
          this.$swal.fire({
            title: "Generando reporte...",
            text: "Por favor espera",
            timerProgressBar: true,
            allowOutsideClick: false,
            didOpen: () => {
              this.$swal.showLoading();
            },
          });
          await XLSXpopulate.fromDataAsync(template)
            .then((wb) => {
              let lastRow = 6 + data.length;
              wb.definedName("ConteoPlanes", `'DATOS'!$AK$6:$AV${lastRow}`);
              wb.definedName("CantidadPersonas", `'DATOS'!$G$6:$G${lastRow}`);
              wb.definedName("ConteoEstados", `'DATOS'!$AV$6:$AV${lastRow}`);
              wb.definedName("ConteoPersonal", `'DATOS'!$O$6:$O${lastRow}`);
              // dataSociosRange.ref(`'DATOS'!$C$6:$AX${lastRow}`)
              wb.sheet(1)
                .cell(`D3`)
                .value(this.$moment().format("DD/MM/YYYY - HH:mm:ss"));
              data.forEach((customer, index) => {
                wb.sheet(1)
                  .cell(`C${index + 7}`)
                  .value(parseInt(index + 1));
                if (
                  customer.informacionAdicional &&
                  customer.informacionAdicional.contrato
                ) {
                  wb.sheet(1)
                    .cell(`D${index + 7}`)
                    .value(
                      this.cleanString(
                        `${customer.informacionAdicional.contrato}`
                      )
                    );
                }
                if (customer.nombreSocio) {
                  wb.sheet(1)
                    .cell(`E${index + 7}`)
                    .value(this.cleanString(`${customer.nombreSocio}`));
                }
                if (customer.rut) {
                  wb.sheet(1)
                    .cell(`F${index + 7}`)
                    .value(this.cleanString(`${customer.rut}`));
                }
                if (customer.sexo) {
                  wb.sheet(1)
                    .cell(`G${index + 7}`)
                    .value(this.cleanString(`${customer.sexo}`));
                }
                if (
                  customer.informacionGeografica &&
                  customer.informacionGeografica.direccion
                ) {
                  wb.sheet(1)
                    .cell(`H${index + 7}`)
                    .value(
                      this.cleanString(
                        `${customer.informacionGeografica.direccion}`
                      )
                    );
                }
                if (
                  customer.informacionGeografica &&
                  customer.informacionGeografica.ciudad
                ) {
                  wb.sheet(1)
                    .cell(`I${index + 7}`)
                    .value(
                      this.cleanString(
                        `${customer.informacionGeografica.ciudad}`
                      )
                    );
                }
                if (
                  customer.informacionGeografica &&
                  customer.informacionGeografica.region
                ) {
                  wb.sheet(1)
                    .cell(`J${index + 7}`)
                    .value(
                      this.cleanString(
                        `${customer.informacionGeografica.region}`
                      )
                    );
                }
                if (
                  customer.informacionAdicional &&
                  customer.informacionAdicional.comuna
                ) {
                  wb.sheet(1)
                    .cell(`K${index + 7}`)
                    .value(
                      this.cleanString(
                        `${customer.informacionAdicional.comuna}`
                      )
                    );
                }
                if (
                  customer.informacionContacto &&
                  customer.informacionContacto.telefonoFijo
                ) {
                  wb.sheet(1)
                    .cell(`L${index + 7}`)
                    .value(
                      parseInt(
                        this.cleanNum(
                          `${customer.informacionContacto.telefonoFijo}`
                        )
                      )
                    );
                }
                if (
                  customer.informacionContacto &&
                  customer.informacionContacto.celular
                ) {
                  wb.sheet(1)
                    .cell(`M${index + 7}`)
                    .value(
                      parseInt(
                        this.cleanNum(`${customer.informacionContacto.celular}`)
                      )
                    );
                }
                if (customer.autenticacion && customer.autenticacion.email) {
                  wb.sheet(1)
                    .cell(`N${index + 7}`)
                    .value(this.cleanEmail(`${customer.autenticacion.email}`));
                }
                if (customer.perfilCuenta && customer.perfilCuenta.glosa) {
                  wb.sheet(1)
                    .cell(`O${index + 7}`)
                    .value(this.cleanString(`${customer.perfilCuenta.glosa}`));
                }
                if (
                  customer.informacionAdicional &&
                  customer.informacionAdicional.rutTitularConvenio
                ) {
                  wb.sheet(1)
                    .cell(`P${index + 7}`)
                    .value(
                      this.cleanString(
                        `${customer.informacionAdicional.rutTitularConvenio}`
                      )
                    );
                }
                if (customer.fechaInscripcion) {
                  wb.sheet(1)
                    .cell(`Q${index + 7}`)
                    .value(
                      customer.fechaInscripcion
                        ? this.$moment(customer.fechaInscripcion).toDate()
                        : this.$moment("01-01-1900").toDate()
                    );
                }
                if (
                  customer.informacionAdicional &&
                  customer.informacionAdicional.accesoFicha
                ) {
                  wb.sheet(1)
                    .cell(`R${index + 7}`)
                    .value(
                      this.cleanString(
                        `${customer.informacionAdicional.accesoFicha}`
                      )
                    );
                }
                if (
                  customer.informacionAdicional &&
                  customer.informacionAdicional.causaBloqueo
                ) {
                  wb.sheet(1)
                    .cell(`S${index + 7}`)
                    .value(
                      this.cleanString(
                        `${customer.informacionAdicional.causaBloqueo}`
                      )
                    );
                }
                if (
                  customer.informacionAdicional &&
                  customer.informacionAdicional.fechaNacimiento
                ) {
                  wb.sheet(1)
                    .cell(`T${index + 7}`)
                    .value(
                      this.$moment(
                        customer.informacionAdicional.fechaNacimiento
                      ).toDate()
                    );
                }
                if (
                  customer.informacionContacto &&
                  customer.informacionContacto.facebook
                ) {
                  wb.sheet(1)
                    .cell(`U${index + 7}`)
                    .value(
                      this.cleanString(
                        `${customer.informacionContacto.facebook}`
                      )
                    );
                }
                if (
                  customer.informacionContacto &&
                  customer.informacionContacto.instagram
                ) {
                  wb.sheet(1)
                    .cell(`V${index + 7}`)
                    .value(
                      this.cleanString(
                        `${customer.informacionContacto.instagram}`
                      )
                    );
                }
                if (
                  customer.informacionContacto &&
                  (customer.informacionContacto.twitter ||
                    customer.informacionContacto.linkedin)
                ) {
                  wb.sheet(1)
                    .cell(`W${index + 7}`)
                    .value(
                      this.cleanString(
                        `${customer.informacionContacto.twitter}`
                      ) ||
                        this.cleanString(
                          `${customer.informacionContacto.linkedin}`
                        )
                    );
                }

                if (customer.plan) {
                  wb.sheet(1)
                    .cell(`AK${index + 7}`)
                    .value(this.cleanString(`${customer.plan.convenio.glosa}`));
                  wb.sheet(1)
                    .cell(`AL${index + 7}`)
                    .value(this.cleanString(`${customer.plan.nombreFamilia}`));
                  wb.sheet(1)
                    .cell(`AM${index + 7}`)
                    .value(
                      this.cleanString(`${customer.plan.nombreSubFamilia}`)
                    );
                  wb.sheet(1)
                    .cell(`AN${index + 7}`)
                    .value(
                      this.cleanString(`${customer.plan.descripcionPlan}`)
                    );
                  wb.sheet(1)
                    .cell(`AO${index + 7}`)
                    .value(`${parseFloat(customer.plan.valorPlan)}` || "0");
                  wb.sheet(1)
                    .cell(`AP${index + 7}`)
                    .value(customer.plan.indicadorMatricula ? "SI" : "NO");
                  // .value(customer.plan.indicadorMatricula ? 1 : 0);
                  wb.sheet(1)
                    .cell(`AQ${index + 7}`)
                    .value(parseFloat(customer.plan.valorMatricula));
                  if (customer.plan.fechaUltimoPago) {
                    wb.sheet(1)
                      .cell(`AR${index + 7}`)
                      .value(
                        customer.plan.fechaUltimoPago
                          ? this.$moment(
                              customer.plan.fechaUltimoPago,
                              "DD-MM-YYYY"
                            ).toDate()
                          : this.$moment("01-01-1900").toDate()
                      );
                  }
                  wb.sheet(1)
                    .cell(`AS${index + 7}`)
                    .value(parseFloat(customer.plan.porcentajeDescuento) || 0);
                  wb.sheet(1)
                    .cell(`AT${index + 7}`)
                    .value(customer.plan.indicadorFactura ? "SI" : "NO");
                  wb.sheet(1)
                    .cell(`AU${index + 7}`)
                    // .value(customer.plan.tipoIVA);
                    .value(this.cleanString(`${customer.plan.tipoIVA}`));
                  wb.sheet(1)
                    .cell(`AV${index + 7}`)
                    .value(
                      this.cleanString(`${customer.plan.estadoPago.glosa}`)
                    );
                  wb.sheet(1)
                    .cell(`AW${index + 7}`)
                    .value(
                      customer.plan.fechaAsignacion
                        ? this.$moment(customer.plan.fechaAsignacion).toDate()
                        : this.$moment("01-01-1900").toDate()
                    );
                  wb.sheet(1)
                    .cell(`AX${index + 7}`)
                    .value(
                      customer.plan.fechaInicio
                        ? this.$moment(
                            customer.plan.fechaInicio,
                            "DD-MM-YYYY"
                          ).toDate()
                        : this.$moment("01-01-1900").toDate()
                    );
                  // console.log(
                  //   "customer.plan.fechaVencimiento" +
                  //     customer.plan.fechaVencimiento
                  // );
                  wb.sheet(1)
                    .cell(`AY${index + 7}`)
                    .value(
                      customer.plan.fechaVencimiento
                        ? this.$moment(
                            customer.plan.fechaVencimiento,
                            "DD-MM-YYYY"
                          ).toDate()
                        : this.$moment("01-01-1900").toDate()
                    );
                  wb.sheet(1)
                    .cell(`AZ${index + 7}`)
                    .value(
                      customer.plan.fechaVigencia
                        ? this.$moment(
                            customer.plan.fechaVigencia,
                            "DD-MM-YYYY"
                          ).toDate()
                        : this.$moment("01-01-1900").toDate()
                    );
                  wb.sheet(1)
                    .cell(`BA${index + 7}`)
                    .value(
                      customer.plan.fechaUltimoPago
                        ? this.$moment(
                            customer.plan.fechaUltimoPago,
                            "DD-MM-YYYY"
                          ).toDate()
                        : this.$moment("01-01-1900")
                    );
                  wb.sheet(1)
                    .cell(`BB${index + 7}`)
                    .value(customer.plan.horaUltimoPago || "00:00:00");
                  wb.sheet(1)
                    .cell(`BC${index + 7}`)
                    .value(parseInt(customer.plan.duracionPlan) || 0);
                  wb.sheet(1)
                    .cell(`BD${index + 7}`)
                    .value(
                      this.cleanString(
                        `${customer.plan.unidadDuracionPlan.glosa}`
                      )
                    );
                  wb.sheet(1)
                    .cell(`BE${index + 7}`)
                    .value(customer.plan.indicadorMesCalendario ? "SI" : "NO");
                  wb.sheet(1)
                    .cell(`BF${index + 7}`)
                    .value(customer.plan.indicadorUsoSesiones ? "SI" : "NO");
                  wb.sheet(1)
                    .cell(`BG${index + 7}`)
                    .value(parseInt(customer.plan.sesionesUtilizadas) || 0);
                  wb.sheet(1)
                    .cell(`BH${index + 7}`)
                    .value(parseInt(customer.plan.sesionesLimite) || 0);
                  wb.sheet(1)
                    .cell(`BI${index + 7}`)
                    .value(customer.plan.indicadorPermiteRenovar ? "SI" : "NO");
                  wb.sheet(1)
                    .cell(`BJ${index + 7}`)
                    .value(parseInt(customer.plan.expiracionRenovacion) || 0);
                  wb.sheet(1)
                    .cell(`BK${index + 7}`)
                    .value(
                      this.cleanString(
                        `${customer.plan.unidadExpiracionRenovacion.glosa}`
                      )
                    );
                  wb.sheet(1)
                    .cell(`BL${index + 7}`)
                    .value(parseInt(customer.plan.diasPermitidoCongelar) || 0);
                  wb.sheet(1)
                    .cell(`BM${index + 7}`)
                    .value(`${customer.plan.turno.idTurno}` || "0");
                  if (customer.plan.sucursalUltimoPago) {
                    wb.sheet(1)
                      .cell(`BN${index + 7}`)
                      .value(
                        this.cleanString(`${customer.plan.sucursalUltimoPago}`)
                      );
                  }
                  if (customer.plan.fechaHoraUltimoAcceso) {
                    wb.sheet(1)
                      .cell(`BO${index + 7}`)
                      .value(
                        customer.plan.fechaHoraUltimoAcceso
                          ? this.$moment(
                              customer.plan.fechaHoraUltimoAcceso,
                              "DD-MM-YYYY"
                            ).toDate()
                          : this.$moment("01-01-1900").toDate()
                      );
                  }
                  wb.sheet(1)
                    .cell(`BP${index + 7}`)
                    .value(
                      this.cleanString(
                        `${customer.plan.nombreSucursalAsignacion}`
                      )
                    );
                  wb.sheet(1)
                    .cell(`BQ${index + 7}`)
                    .value(
                      this.cleanString(
                        `${customer.plan.nombreUsuarioAsignacion}`
                      )
                    );
                }
              });
              wb.outputAsync()
                .then((blob) => {
                  if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                    // If IE, you must uses a different method.
                    window.navigator.msSaveOrOpenBlob(
                      blob,
                      `Base de Datos - Personas Registradas [${this.$moment().format(
                        "DD-MM-yyyy"
                      )}].xlsx`
                    );
                  } else {
                    var url = window.URL.createObjectURL(blob);
                    var a = document.createElement("a");
                    document.body.appendChild(a);
                    a.href = url;
                    a.download = `Base de Datos - Personas Registradas [${this.$moment().format(
                      "DD-MM-yyyy"
                    )}].xlsx`;
                    a.click();
                    window.URL.revokeObjectURL(url);
                    document.body.removeChild(a);
                  }
                })
                .catch((ex) => {
                  this.$swal({
                    title: "Error :(!",
                    text:
                      ex.message ||
                      "Ha ocurrido un error durante la descarga, ponte en contacto con soporte",
                    icon: "error",
                  });
                });
            })
            .catch((ex) => {
              console.error("WorkBook Error");
              console.error(ex);
              this.$swal({
                title: "Error :(!",
                text: "Ha ocurrido un error durante la generación del reporte, vuelve a intentarlo, si el problema persiste contactate con soporte",
                icon: "error",
              });
            });
          // console.log("reseting progressbar");
          this.$swal.close();
          this.customersReportTotal = 0;
          this.customersReportCurrent = 0;
          this.$swal.fire({
            title: "EXITO!",
            text: "Reporte generado de exitosamente",
            icon: "success",
            confirmButtonColor: "#6bd098",
            confirmButtonText: "ok",
          });
        }
      } catch (ex) {
        console.error("error - renderCustomersReportXLSX");
        // console.error(ex);
        console.error(ex);
        this.$swal({
          title: "Error :(!",
          text:
            ex.message ||
            "Ha ocurrido un error durante la generación del reporte, vuelve a intentarlo, si el problema persiste contactate con soporte",
          icon: "error",
        });
      } finally {
      }
    },
    async renderCustomersReportXLSXv2(templateName) {
      this.$swal.fire({
        title: "Creando plantilla...",
        text: "Por favor espera",
        timerProgressBar: true,
        allowOutsideClick: false,
        didOpen: () => {
          this.$swal.showLoading();
        },
      });
      // const filePath = "./assets/templates/ListaPersonas.xlsx";

      try {
        // const wsTemplate =
        //   customersReportWB.Sheets[customersReportWB.SheetNames["DATOS"]];
        const template = await this.fetchTemplate(templateName);
        const wb = new ExcelJS.Workbook();
        await wb.xlsx.load(template);
        // console.log(wb)
        const ws = wb.getWorksheet("DATOS");

        const data = await this.createXLSXCustomerReportData();

        if (data.length > 0) {
          this.$swal.fire({
            title: "Renderizando reporte...",
            text: "Por favor espera",
            timerProgressBar: true,
            allowOutsideClick: false,
            didOpen: () => {
              this.$swal.showLoading();
            },
          });
          ws.getCell("D3").value = this.$moment().format(
            "DD/MM/YYYY - HH:mm:ss"
          );
          data.forEach((customer, index) => {
            const rowIndex = index + 7;
            ws.getCell(`C${rowIndex}`).value = index + 1;
            if (
              customer.informacionAdicional &&
              customer.informacionAdicional.contrato
            ) {
              ws.getCell(`D${rowIndex}`).value = this.cleanString(
                `${customer.informacionAdicional.contrato}`
              );
            }
            if (customer.nombreSocio) {
              ws.getCell(`E${index + 7}`).value = this.cleanString(
                `${customer.nombreSocio}`
              );
            }
            if (customer.rut) {
              ws.getCell(`F${index + 7}`).value = this.cleanString(
                `${customer.rut}`
              );
            }
            if (customer.sexo) {
              ws.getCell(`G${index + 7}`).value = this.cleanString(
                `${customer.sexo}`
              );
            }
            if (
              customer.informacionGeografica &&
              customer.informacionGeografica.direccion
            ) {
              ws.getCell(`H${index + 7}`).value = this.cleanString(
                `${customer.informacionGeografica.direccion}`
              );
            }
            if (
              customer.informacionGeografica &&
              customer.informacionGeografica.ciudad
            ) {
              ws.getCell(`I${index + 7}`).value = this.cleanString(
                `${customer.informacionGeografica.ciudad}`
              );
            }
            if (
              customer.informacionGeografica &&
              customer.informacionGeografica.region
            ) {
              ws.getCell(`J${index + 7}`).value = this.cleanString(
                `${customer.informacionGeografica.region}`
              );
            }
            if (
              customer.informacionAdicional &&
              customer.informacionAdicional.comuna
            ) {
              ws.getCell(`K${index + 7}`).value = this.cleanString(
                `${customer.informacionAdicional.comuna}`
              );
            }
            if (
              customer.informacionContacto &&
              customer.informacionContacto.telefonoFijo
            ) {
              ws.getCell(`L${index + 7}`).value = parseInt(
                this.cleanNum(`${customer.informacionContacto.telefonoFijo}`)
              );
            }
            if (
              customer.informacionContacto &&
              customer.informacionContacto.celular
            ) {
              ws.getCell(`M${index + 7}`).value = parseInt(
                this.cleanNum(`${customer.informacionContacto.celular}`)
              );
            }
            if (customer.autenticacion && customer.autenticacion.email) {
              ws.getCell(`N${index + 7}`).value = this.cleanEmail(
                `${customer.autenticacion.email}`
              );
            }
            if (customer.perfilCuenta && customer.perfilCuenta.glosa) {
              ws.getCell(`O${index + 7}`).value = this.cleanString(
                `${customer.perfilCuenta.glosa}`
              );
            }
            if (
              customer.informacionAdicional &&
              customer.informacionAdicional.rutTitularConvenio
            ) {
              ws.getCell(`P${index + 7}`).value = this.cleanString(
                `${customer.informacionAdicional.rutTitularConvenio}`
              );
            }
            if (customer.fechaInscripcion) {
              ws.getCell(`Q${index + 7}`).value = customer.fechaInscripcion
                ? this.$moment(customer.fechaInscripcion).toDate()
                : this.$moment("01-01-1900").toDate();
            }
            if (
              customer.informacionAdicional &&
              customer.informacionAdicional.accesoFicha
            ) {
              ws.getCell(`R${index + 7}`).value = this.cleanString(
                `${customer.informacionAdicional.accesoFicha}`
              );
            }
            if (
              customer.informacionAdicional &&
              customer.informacionAdicional.causaBloqueo
            ) {
              ws.getCell(`S${index + 7}`).value = this.cleanString(
                `${customer.informacionAdicional.causaBloqueo}`
              );
            }
            if (
              customer.informacionAdicional &&
              customer.informacionAdicional.fechaNacimiento
            ) {
              ws.getCell(`T${index + 7}`).value = this.$moment(
                customer.informacionAdicional.fechaNacimiento
              ).toDate();
            }
            if (
              customer.informacionContacto &&
              customer.informacionContacto.facebook
            ) {
              ws.getCell(`U${index + 7}`).value = this.cleanString(
                `${customer.informacionContacto.facebook}`
              );
            }
            if (
              customer.informacionContacto &&
              customer.informacionContacto.instagram
            ) {
              ws.getCell(`V${index + 7}`).value = this.cleanString(
                `${customer.informacionContacto.instagram}`
              );
            }
            if (
              customer.informacionContacto &&
              (customer.informacionContacto.twitter ||
                customer.informacionContacto.linkedin)
            ) {
              ws.getCell(`W${index + 7}`).value =
                this.cleanString(`${customer.informacionContacto.twitter}`) ||
                this.cleanString(`${customer.informacionContacto.linkedin}`);
            }
            if (customer.plan) {
              ws.getCell(`AK${index + 7}`).value = this.cleanString(
                `${customer.plan.convenio.glosa}`
              );
              ws.getCell(`AL${index + 7}`).value = this.cleanString(
                `${customer.plan.nombreFamilia}`
              );
              ws.getCell(`AM${index + 7}`).value = this.cleanString(
                `${customer.plan.nombreSubFamilia}`
              );
              ws.getCell(`AN${index + 7}`).value = this.cleanString(
                `${customer.plan.descripcionPlan}`
              );
              ws.getCell(`AO${index + 7}`).value =
                `${parseFloat(customer.plan.valorPlan)}` || "0";
              ws.getCell(`AP${index + 7}`).value = customer.plan
                .indicadorMatricula
                ? "SI"
                : "NO";
              // .value(customer.plan.indicadorMatricula ? 1 : 0);
              ws.getCell(`AQ${index + 7}`).value = parseFloat(
                customer.plan.valorMatricula
              );
              if (customer.plan.fechaUltimoPago) {
                ws.getCell(`AR${index + 7}`).value = customer.plan
                  .fechaUltimoPago
                  ? this.$moment(
                      customer.plan.fechaUltimoPago,
                      "DD-MM-YYYY"
                    ).toDate()
                  : this.$moment("01-01-1900").toDate();
              }
              ws.getCell(`AS${index + 7}`).value =
                parseFloat(customer.plan.porcentajeDescuento) || 0;
              ws.getCell(`AT${index + 7}`).value = customer.plan
                .indicadorFactura
                ? "SI"
                : "NO";
              ws.getCell(`AU${index + 7}`).value = this.cleanString(
                `${customer.plan.tipoIVA}`
              );
              ws.getCell(`AV${index + 7}`).value = this.cleanString(
                `${customer.plan.estadoPago.glosa}`
              );
              ws.getCell(`AW${index + 7}`).value = customer.plan.fechaAsignacion
                ? this.$moment(customer.plan.fechaAsignacion).toDate()
                : this.$moment("01-01-1900").toDate();
              ws.getCell(`AX${index + 7}`).value = customer.plan.fechaInicio
                ? this.$moment(customer.plan.fechaInicio, "DD-MM-YYYY").toDate()
                : this.$moment("01-01-1900").toDate();
              ws.getCell(`AY${index + 7}`).value = customer.plan
                .fechaVencimiento
                ? this.$moment(
                    customer.plan.fechaVencimiento,
                    "DD-MM-YYYY"
                  ).toDate()
                : this.$moment("01-01-1900").toDate();
              ws.getCell(`AZ${index + 7}`).value = customer.plan.fechaVigencia
                ? this.$moment(
                    customer.plan.fechaVigencia,
                    "DD-MM-YYYY"
                  ).toDate()
                : this.$moment("01-01-1900").toDate();
              ws.getCell(`BA${index + 7}`).value = customer.plan.fechaUltimoPago
                ? this.$moment(
                    customer.plan.fechaUltimoPago,
                    "DD-MM-YYYY"
                  ).toDate()
                : this.$moment("01-01-1900");
              ws.getCell(`BB${index + 7}`).value =
                customer.plan.horaUltimoPago || "00:00:00";
              ws.getCell(`BC${index + 7}`).value =
                parseInt(customer.plan.duracionPlan) || 0;
              ws.getCell(`BD${index + 7}`).value = this.cleanString(
                `${customer.plan.unidadDuracionPlan.glosa}`
              );
              ws.getCell(`BE${index + 7}`).value = customer.plan
                .indicadorMesCalendario
                ? "SI"
                : "NO";
              ws.getCell(`BF${index + 7}`).value = customer.plan
                .indicadorUsoSesiones
                ? "SI"
                : "NO";
              ws.getCell(`BG${index + 7}`).value =
                parseInt(customer.plan.sesionesUtilizadas) || 0;
              ws.getCell(`BH${index + 7}`).value =
                parseInt(customer.plan.sesionesLimite) || 0;
              ws.getCell(`BI${index + 7}`).value = customer.plan
                .indicadorPermiteRenovar
                ? "SI"
                : "NO";
              ws.getCell(`BJ${index + 7}`).value =
                parseInt(customer.plan.expiracionRenovacion) || 0;
              ws.getCell(`BK${index + 7}`).value = this.cleanString(
                `${customer.plan.unidadExpiracionRenovacion.glosa}`
              );
              ws.getCell(`BL${index + 7}`).value =
                parseInt(customer.plan.diasPermitidoCongelar) || 0;
              ws.getCell(`BM${index + 7}`).value =
                `${customer.plan.turno.idTurno}` || "0";
              if (customer.plan.sucursalUltimoPago) {
                ws.getCell(`BN${index + 7}`).value = this.cleanString(
                  `${customer.plan.sucursalUltimoPago}`
                );
              }
              if (customer.plan.fechaHoraUltimoAcceso) {
                ws.getCell(`BO${index + 7}`).value = customer.plan
                  .fechaHoraUltimoAcceso
                  ? this.$moment(
                      customer.plan.fechaHoraUltimoAcceso,
                      "DD-MM-YYYY"
                    ).toDate()
                  : this.$moment("01-01-1900").toDate();
              }
              ws.getCell(`BP${index + 7}`).value = this.cleanString(
                `${customer.plan.nombreSucursalAsignacion}`
              );
              ws.getCell(`BQ${index + 7}`).value = this.cleanString(
                `${customer.plan.nombreUsuarioAsignacion}`
              );
            }
          });
          const buffer = await wb.xlsx.writeBuffer();
          // console.log("reseting progressbar");
          this.downloadFile(
            buffer,
            `Base de Datos - Personas Registradas [${this.$moment().format(
              "DD-MM-YYYY HH:mm"
            )}].xlsx`
          );
        }
      } catch (error) {
        console.error("error - renderCustomersReportXLSX");
        console.error(error);
      } finally {
        this.$swal.close();
        this.customersReportTotal = 0;
        this.customersReportCurrent = 0;
        this.$swal.fire({
          title: "EXITO!",
          text: "Reporte generado de exitosamente",
          icon: "success",
          confirmButtonColor: "#6bd098",
          confirmButtonText: "ok",
        });
      }
    },
    downloadFile(buffer, filename) {
      const blob = new Blob([buffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      document.body.appendChild(a);
      a.href = url;
      a.download = filename;
      a.click();
      window.URL.revokeObjectURL(url);
      document.body.removeChild(a);
    },
    async createXLSXCustomerReportData() {
      let collectedData = [];
      this.customersReportCurrent = collectedData.length;

      this.$swal.fire({
        title: "Descargando registros...",
        text: `${collectedData.length} de ${this.customersReportTotal}`,
        timerProgressBar: true,
        allowOutsideClick: false,
        showConfirmButton: false,
        didOpen: () => {
          this.$swal.showLoading();
        },
      });
      const inicio = new Date().getTime();
      let currentPage = 0;

      try {
        let count = await this.fetchCustomersCount();
        let pageData = await this.fetchCustomerReportData(currentPage);
        this.$swal.update({
          text: `${collectedData.length} de ${this.customersReportTotal}`,
        });
        this.customersReportCurrent = pageData.length;
        this.$swal.showLoading();
        while (pageData.length > 0) {
          // console.log(pageData)
          collectedData = [...collectedData, ...pageData];
          this.customersReportCurrent = collectedData.length;
          currentPage++;
          pageData = await this.fetchCustomerReportData(currentPage);
          // console.log("pageData.lenght: ", pageData.length);
          this.$swal.update({
            text: `${collectedData.length} de ${this.customersReportTotal}`,
          });
          this.$swal.showLoading();
        }
      } catch (error) {
        console.error("error - createXLSXCustomerReportData");
        console.error(error);
      } finally {
        const fin = new Date().getTime();
        const tiempoEjecucion = (fin - inicio) / 1000;
        // console.log(
        //   `La descarga tardó ${tiempoEjecucion} segundos en ejecutarse.`
        // );
        // console.log("fin - createXLSXCustomerReportData");
        // console.log(collectedData);
        return collectedData;
      }
    },
    async fetchCustomerReportData(page) {
      console.log("fetching page n°: ", page);
      let response;
      try {
        response = await this.$MasterControlAPP.post(
          "",
          {
            Parameters: { page: page },
          },
          {
            headers: {
              "Content-Type": "application/json",
              token: sessionStorage.getItem("jCxbraoQeD"),
              operation: "/v1/get/customers/report/data",
              // operation: JSON.parse(sessionStorage.getItem("wxZlBbdD4q")).MembershipsStatistics,
            },
          }
        );
        // console.log(response.data);
        return response.data;
      } catch (error) {
        console.error("error - fetchCustomerReportData");
        console.error(error);
      }
    },
    async renderAccessReportXLSX(templateName) {
      const values = await this.$swal
        .fire({
          title: "Seleccione un rango de fechas",
          html: `
          <div class=" flex-column">
            <label for= "start">Desde:</label>
            <input id="start" type="date" class="swal2-input w-50" v-model="dateStart">
          </div><div class=" flex-column">
            <label for="end">Hasta:</label>
            <input id="end" type="date" class="swal2-input w-50" >
          </div>
          `,
          focusConfirm: false,
          preConfirm: () => {
            return [
              document.getElementById("start").value,
              document.getElementById("end").value,
            ];
          },
        })
        .then((res) => {
          return res.value;
        });

      // console.log(values);
    },
  },
  mounted() {
    if (this.$sidebar.isMinimized) {
      this.$sidebar.toggleMinimize();
    }
    this.$swal.close();
  },
  beforeDestroy() {
    this.$swal.fire({
      title: "Cargando ...",
      text: "Por favor espera",
      timerProgressBar: true,
      allowOutsideClick: false,
      didOpen: () => {
        this.$swal.showLoading();
      },
    });
  },
};
</script>

<style></style>
